/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../store/useAuth";
import { ComponentType, useEffect } from "react";

/**
 * ADMIN and SUPER_ADMIN only - the two roles the backend lets set the carrier
 * flag (it strips `isCourier` from anyone else's payload). Without this the
 * page would be reachable by URL for a store admin or an employee, who could
 * fill the whole form in and quietly create an ordinary partner.
 */
export const withCarrierPermission = (WrappedComponent: ComponentType<any>) => {
  return function WithCarrierPermission(props: JSX.IntrinsicAttributes) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const canManageCarriers = [1, 7].includes(user?.user_role ?? -1);

    useEffect(() => {
      if (!canManageCarriers) {
        navigate("/partners", { replace: true });
      }
    }, [canManageCarriers]);

    if (!canManageCarriers) return null;
    return <WrappedComponent {...props} />;
  };
};
